export default "__VITE_ASSET__DwS1fN2j__"